import { ThumbsDown, ThumbsUp } from 'lucide-react';

type ApplicationAcceptedProps = {
  accepted: boolean | null | undefined;
};

const ApplicationAccepted = ({ accepted }: ApplicationAcceptedProps) => {
  if (accepted === true)
    return (
      <div className="flex justify-center">
        <ThumbsUp className="bg-evaluation-bonus h-6 w-6" />
      </div>
    );
  else if (accepted === false)
    return (
      <div className="flex justify-center">
        <ThumbsDown className="h-6 w-6" />
      </div>
    );

  return <div className="flex justify-center">{` - `}</div>;
};

export default ApplicationAccepted;
